import React from "react";
import { IVehicle } from "../../classes/ExternalQuote";
import Utilities from "../../classes/Utilities";

interface IProps {
	vehicle: IVehicle;
}

class VehicleCoverages extends React.Component<IProps> {
	constructor(props: IProps) {
		super(props);
	}

	render() {
		return (
            <div className="vehicle-coverages">
                <div className="break-2" />
                <div className="titleArea">
                    <h5>{`${this.props.vehicle.year} ${this.props.vehicle.make} ${this.props.vehicle.model}`}</h5>
                </div>

                <div className="info-disclosure quote-info">
                    {this.props.vehicle.coverages.map((c, idx, arr) => (
                        <div className={"item" + (idx === arr.length - 1 ? " no-border" : "")} key={Utilities.uniqueId()}>
                            <label className="left-cell">{c.name}</label>
                            <label className="right-cell">{c.limit ? c.limit : "No Coverage"}</label>
                        </div>
                    ))}
                </div>
			</div>
		);
	}
}

export default VehicleCoverages;